import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a06a6b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg text-textPrimary text-center w-full" }, "Filtros", -1))
const _hoisted_2 = { class: "flex flex-grow overflow-hidden p-0 m-0 -mx-6 -my-4" }
const _hoisted_3 = { class: "w-1/4 bg-gray-50 border-r border-gray-200 flex-shrink-0" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "font-bold text-gray-800 mb-6 text-left" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-6" }
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "font-bold text-gray-800 mb-6 text-left" }
const _hoisted_10 = { class: "grid grid-cols-1 gap-6" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "font-bold text-gray-800 mb-6 text-left" }
const _hoisted_13 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_14 = { class: "flex justify-between w-full gap-x-3 mt-12" }

import { computed, defineAsyncComponent, ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { DatePicker } from 'v-calendar'
import 'v-calendar/style.css'
import { mdiCalendarBlankOutline } from '@mdi/js'
import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import Network from '@/Network'
import { useOperationalGroups } from '@/hooks/useOperationalGroups'
import { format, parseISO } from 'date-fns'
import { useDoctorStore } from '@/pinia-store/useDoctorStore'
import ScheduleService from '@/Network/Services/ScheduleUnitService'


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  activeFilters: {
    type: Object,
    required: true
  }
},
  emits: ['update:isOpen', 'apply-filters'],
  setup(__props, { emit }) {

const props = __props;





const getInitialFilters = () => JSON.parse(JSON.stringify(props.activeFilters))

const localFilters = ref(getInitialFilters())

const positionsData = ref<any[]>([])
const positionsOptions = computed(() =>
  positionsData.value.map((pos) => ({
    title: pos.name,
    value: pos.id
  }))
)

const { options: operationalGroupOpts, load: loadOperationalGroups } = useOperationalGroups()
const operationalGroupOptions = computed(() =>
  operationalGroupOpts.value.map((opt) => ({
    title: opt.label,
    value: opt.value
  }))
)

const shiftData = ref<any[]>([])
// const shiftsOptions = computed(() =>
//   shiftData.value.map((pos) => ({
//     title: pos.name,
//     value: pos.id
//   }))
// )

const loadFilterOptions = async () => {
  try {
    const [positionsRes, shiftRes] = await Promise.all([
      Network.position.get(),
      Network.shift.get()
    ])

    positionsData.value = positionsRes
    shiftData.value = shiftRes
  } catch (error) {
    console.error('Erro ao carregar as opções dos filtros:', error)
  }
}

const healthUnitStore = useHealthUnitStore()
const scheduleStore = useScheduleStore()
const doctorStore = useDoctorStore()

watch(
  () => props.isOpen,
  (isOpening) => {
    if (isOpening) {
      localFilters.value = getInitialFilters()
      healthUnitStore.fetchAllHealthUnitsForSelect()
      scheduleStore.getAllSchedules()
      doctorStore.fetchAllDoctorsForFilter()
      loadFilterOptions()
      loadOperationalGroups()
    }
  }
)

const formattedStartDate = computed(() => {
  if (!localFilters.value.startDate) return ''
  const date =
    localFilters.value.startDate instanceof Date
      ? localFilters.value.startDate
      : parseISO(localFilters.value.startDate)
  return format(date, 'dd/MM/yyyy')
})

const formattedEndDate = computed(() => {
  if (!localFilters.value.endDate) return ''
  const date =
    localFilters.value.endDate instanceof Date
      ? localFilters.value.endDate
      : parseISO(localFilters.value.endDate)
  return format(date, 'dd/MM/yyyy')
})

const ScaleIcon = defineAsyncComponent(() => import(`@/assets/icons/scale.vue`))
const ShiftIcon = defineAsyncComponent(() => import(`@/assets/icons/hospital.vue`))
const WorkJourneyIcon = defineAsyncComponent(() => import(`@/assets/icons/clock.vue`))
// const PaymentIcon = defineAsyncComponent(() => import(`@/assets/icons/money.vue`))

const { listCompanies } = storeToRefs(useCompanyStore())
// const { listSchedules } = storeToRefs(scheduleStore)
const { listHealthUnits } = storeToRefs(healthUnitStore)
const { listDoctorsCompany } = storeToRefs(doctorStore)

const listAdminUsers = ref<{ id: number; name: string }[]>([])
const scheduleService = new ScheduleService()

// Se o backend ainda não expõe companyId (deploy do front antes do da API,
// bundle em cache, rollback), a cascata fica inerte e o select mostra todas as
// unidades — falha para o lado seguro, em vez de ficar vazio.
const hasCompanyMetadata = computed(() =>
  listHealthUnits.value.some((unit) => unit.companyId !== undefined)
)

const healthUnitOptions = computed(() => {
  const selectedCompanyIds = localFilters.value.companyIds ?? []
  const canCascade = selectedCompanyIds.length > 0 && hasCompanyMetadata.value
  const units = canCascade
    ? listHealthUnits.value.filter((unit) => selectedCompanyIds.includes(unit.companyId))
    : listHealthUnits.value

  return units.map((unit) => ({
    title: unit.title,
    value: String(unit.value)
  }))
})

const fetchAdminUsers = async (scheduleId: number) => {
  try {
    listAdminUsers.value = await scheduleService.stationCreatingUsers(scheduleId)
  } catch (error) {
    // fallback intencional: o único consumidor de `listAdminUsers` é o select
    // "Alocador", que está comentado no template (funcionalidade em
    // desenvolvimento). Sem campo na tela, um toast avisaria sobre um filtro que
    // o usuário nem vê. Ao reativar o select, trocar por
    // `notifyError(error, 'Não foi possível carregar os responsáveis pela escala.')`
    // e estado visível no campo.
    console.error('Error fetching admin users:', error)
  }
}

watch(
  () => localFilters.value.companyIds,
  () => {
    const selectedCompanyIds = localFilters.value.companyIds ?? []
    if (selectedCompanyIds.length > 0) {
      localFilters.value.healthUnitIds = (localFilters.value.healthUnitIds ?? []).filter(
        (huId: string) => healthUnitOptions.value.some((opt) => opt.value === huId)
      )
    }
  }
)

watch(
  () => localFilters.value.scheduleId,
  (newScheduleId) => {
    if (newScheduleId) {
      fetchAdminUsers(newScheduleId)
    } else {
      listAdminUsers.value = []
    }
  },
  { immediate: true }
)

const sections = ref([
  { id: 'escala', title: 'Escala', icon: ScaleIcon },
  { id: 'plantao', title: 'Plantão', icon: ShiftIcon },
  { id: 'jornada', title: 'Jornada de trabalho', icon: WorkJourneyIcon }
  // { id: 'pagamento', title: 'Pagamento', icon: PaymentIcon }
])

const contentArea = ref<HTMLElement | null>(null)
const activeSection = ref('escala')

function closeModal() {
  emit('update:isOpen', false)
}

function applyFilters() {
  const filtersToApply = { ...localFilters.value }

  if (filtersToApply.startDate instanceof Date) {
    filtersToApply.startDate = filtersToApply.startDate.toISOString()
  }

  if (filtersToApply.endDate instanceof Date) {
    filtersToApply.endDate.setHours(23, 59, 59, 999)
    filtersToApply.endDate = filtersToApply.endDate.toISOString()
  }

  emit('apply-filters', filtersToApply)
  closeModal()
}

function clearFilters() {
  localFilters.value = {
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
    endDate: new Date().toISOString(),
    companyIds: [],
    healthUnitIds: [],
    doctorIds: [],
    positionIds: [],
    operationalGroups: [],
    isChecked: undefined,
    paymentTiming: undefined,
    hasException: undefined
  }
}

function scrollToSection(sectionId: string) {
  const sectionElement = document.getElementById(sectionId)
  if (sectionElement && contentArea.value) {
    contentArea.value.scrollTo({
      top: sectionElement.offsetTop - contentArea.value.offsetTop,
      behavior: 'smooth'
    })
  }
}

function handleScroll() {
  const scrollContainer = contentArea.value
  if (!scrollContainer) return

  const scrollPosition = scrollContainer.scrollTop
  const scrollOffset = 100
  let currentSectionId = sections.value[0].id

  for (const section of sections.value) {
    const sectionElement = document.getElementById(section.id) as HTMLElement
    if (
      sectionElement &&
      sectionElement.offsetTop - scrollContainer.offsetTop <= scrollPosition + scrollOffset
    ) {
      currentSectionId = section.id
    }
  }
  activeSection.value = currentSectionId
}

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(Modal, {
    "modal-active": __props.isOpen,
    onClose: closeModal,
    "max-width": "max-w-4xl",
    "max-height": "65vh"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section) => {
              return (_openBlock(), _createElementBlock("a", {
                key: section.id,
                href: "#",
                onClick: _withModifiers(($event: any) => (scrollToSection(section.id)), ["prevent"]),
                class: _normalizeClass([
              'flex items-center p-4 text-sm font-medium transition-colors',
              activeSection.value === section.id
                ? 'bg-primary30 text-white'
                : 'text-textPrimary hover:bg-gray-200'
            ])
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(section.icon), {
                  class: "h-5 w-5 mr-3",
                  color: activeSection.value === section.id ? 'white' : 'black'
                }, null, 8, ["color"])),
                _createElementVNode("span", {
                  class: _normalizeClass(activeSection.value === section.id && 'font-bold')
                }, _toDisplayString(section.title), 3)
              ], 10, _hoisted_4))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          ref_key: "contentArea",
          ref: contentArea,
          onScroll: handleScroll,
          class: "flex-grow p-6 overflow-y-auto"
        }, [
          _createElementVNode("div", {
            id: sections.value[0].id,
            class: "mb-10"
          }, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(sections.value[0].title), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_autocomplete, {
                label: "Empresa",
                items: _unref(listCompanies),
                modelValue: localFilters.value.companyIds,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localFilters.value.companyIds) = $event)),
                multiple: "",
                chips: "",
                "closable-chips": "",
                variant: "outlined",
                density: "compact",
                class: "multi-chip-autocomplete",
                "hide-details": ""
              }, null, 8, ["items", "modelValue"]),
              _createVNode(_component_v_autocomplete, {
                label: "Unidades",
                items: healthUnitOptions.value,
                modelValue: localFilters.value.healthUnitIds,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localFilters.value.healthUnitIds) = $event)),
                multiple: "",
                chips: "",
                "closable-chips": "",
                variant: "outlined",
                density: "compact",
                class: "multi-chip-autocomplete",
                "hide-details": ""
              }, null, 8, ["items", "modelValue"]),
              _createVNode(_component_v_autocomplete, {
                label: "Posições",
                items: positionsOptions.value,
                modelValue: localFilters.value.positionIds,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localFilters.value.positionIds) = $event)),
                multiple: "",
                chips: "",
                "closable-chips": "",
                variant: "outlined",
                density: "compact",
                class: "multi-chip-autocomplete",
                "hide-details": ""
              }, null, 8, ["items", "modelValue"]),
              _createVNode(_component_v_autocomplete, {
                label: "Grupos Operacionais",
                items: operationalGroupOptions.value,
                modelValue: localFilters.value.operationalGroups,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localFilters.value.operationalGroups) = $event)),
                multiple: "",
                chips: "",
                "closable-chips": "",
                clearable: "",
                variant: "outlined",
                density: "compact",
                class: "multi-chip-autocomplete",
                "hide-details": ""
              }, null, 8, ["items", "modelValue"])
            ])
          ], 8, _hoisted_5),
          _createElementVNode("div", {
            id: sections.value[1].id,
            class: "mb-10"
          }, [
            _createElementVNode("h4", _hoisted_9, _toDisplayString(sections.value[1].title), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_v_autocomplete, {
                label: "Médico",
                items: _unref(listDoctorsCompany),
                modelValue: localFilters.value.doctorIds,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localFilters.value.doctorIds) = $event)),
                multiple: "",
                chips: "",
                "closable-chips": "",
                variant: "outlined",
                density: "compact",
                class: "multi-chip-autocomplete",
                "hide-details": "",
                hint: "Funcionalidade em desenvolvimento",
                "persistent-hint": ""
              }, null, 8, ["items", "modelValue"]),
              _createVNode(_component_v_autocomplete, {
                label: "Excepcionalidade",
                items: [
                { title: 'Com excepcionalidade', value: true },
                { title: 'Sem excepcionalidade', value: false }
              ],
                modelValue: localFilters.value.hasException,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localFilters.value.hasException) = $event)),
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                clearable: "",
                "data-testid": "reports-filter-has-exception"
              }, null, 8, ["modelValue"])
            ])
          ], 8, _hoisted_8),
          _createElementVNode("div", {
            id: sections.value[2].id,
            class: "mb-10"
          }, [
            _createElementVNode("h4", _hoisted_12, _toDisplayString(sections.value[2].title), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(DatePicker), {
                modelValue: localFilters.value.startDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((localFilters.value.startDate) = $event))
              }, {
                default: _withCtx(({ inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    "model-value": formattedStartDate.value,
                    label: "Dia inicial",
                    "append-inner-icon": _unref(mdiCalendarBlankOutline)
                  }, _toHandlers(inputEvents), {
                    readonly: "",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": ""
                  }), null, 16, ["model-value", "append-inner-icon"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_unref(DatePicker), {
                modelValue: localFilters.value.endDate,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((localFilters.value.endDate) = $event))
              }, {
                default: _withCtx(({ inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    "model-value": formattedEndDate.value,
                    label: "Dia final",
                    "append-inner-icon": _unref(mdiCalendarBlankOutline)
                  }, _toHandlers(inputEvents), {
                    readonly: "",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": ""
                  }), null, 16, ["model-value", "append-inner-icon"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 8, _hoisted_11),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(OutlinedButton, {
              width: "130px",
              text: "Limpar filtros",
              onClick: clearFilters,
              height: "48px"
            }),
            _createVNode(FilledButton, {
              width: "150px",
              text: "Aplicar filtros",
              onClick: applyFilters,
              height: "48px",
              class: "!bg-primary30"
            })
          ])
        ], 544)
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})